module.exports = __webpack_public_path__ + "static/media/africanunion.ce92e255.svg";